"use client";

import { useEffect, useState, type ComponentPropsWithoutRef } from "react";
import Image from "next/image";
import { useTheme } from "next-themes";
import { cn } from "@/lib/utils";

type BriefcaseCompleteIllustrationProps = Omit<
  ComponentPropsWithoutRef<typeof Image>,
  "src" | "alt"
> & {
  alt?: string;
};

function useBriefcaseCompleteIllustrationSrc() {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return "/assets/jobs/briefcase-complete.svg";
  }

  return resolvedTheme === "light"
    ? "/assets/light/jobs-briefcase-complete.svg"
    : "/assets/jobs/briefcase-complete.svg";
}

export function BriefcaseCompleteIllustration({
  className,
  alt = "",
  width = 69,
  height = 80,
  ...props
}: BriefcaseCompleteIllustrationProps) {
  const src = useBriefcaseCompleteIllustrationSrc();

  return (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={cn("h-20 w-[69px] object-contain", className)}
      {...props}
    />
  );
}
